import { NgSelectComponent, NgOption } from '@ng-select/ng-select';
import { QueryList, ViewChildren } from '@angular/core';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';

export class NgSelectUtil {
    
    static selectAll(id:string,ngSelects:QueryList<NgSelectComponent>){
        ngSelects.forEach(select=>{
            if(select.element.getAttribute("id") == id){
                for(let item of select.items){
                    let isSelected= select.selectedItems.filter(i=>{return NgSelectUtil.isItemEqual(i.value,item)}).length > 0;
                    if(!isSelected){
                        let i = NgSelectUtil.findItem(item,select.itemsList);
                        if(i!= null){
                            select.select(i);
                        }
                    }
                }
            }
        })
    }

    static unSelectAll(id:string,ngSelects:QueryList<NgSelectComponent>){
        ngSelects.forEach(select=>{
            if(select.element.getAttribute("id") == id){
                for(let item of select.items){
                    let isSelected= select.selectedItems.filter(i=>{return NgSelectUtil.isItemEqual(i.value,item)}).length > 0;
                    if(isSelected){
                        let i = select.itemsList.findItem(item);
                        if(i!= null){
                            select.select(i);
                        }
                    }
                }
            }
        })
    }

    static selectItem(id:string,targetValue:any,ngSelects:QueryList<NgSelectComponent>){
        ngSelects.forEach(select=>{
            if(select.element.getAttribute("id") == id){
                for(let item of select.items){
                    if(NgSelectUtil.isItemEqual(item.value,targetValue)){
                        select.select(item);
                    }
                }
            }
        })
    }

    static reload(id:string,fieldNames:string[],ngSelects:QueryList<NgSelectComponent>){
        ngSelects.forEach(select=>{
            if(select.element.getAttribute("id") == id){
                for(let selectedItem of select.selectedItems){
                    for(let itemListItem of select.itemsList.items){
                        if(NgSelectUtil.isItemEqualByFieldNames(selectedItem.value,itemListItem.value,fieldNames)){
                            select.unselect(selectedItem)
                            select.select(itemListItem)
                        }
                    }
                }
            }
        })
    }

    static isItemEqualByFieldNames(item1:any,item2:any,fieldNames:string[]){
        if(fieldNames.length>0){
            for(let fieldName of fieldNames){
                if(item1[fieldName] != item2[fieldName] ){
                    return false;
                }
            }
        }else{
            return NgSelectUtil.isItemEqual(item1,item2)
        }
       
        return true;
    }

    static isItemEqual(item1:any,item2:any):boolean{
        let item1keys:string[] = Object.keys(item1).sort();
        let item2keys:string[] = Object.keys(item2).sort();
        if(JSON.stringify(item1keys) != JSON.stringify(item2keys)){
            return false;
        } else {
            for(let key of item1keys){
                if(item1[key] != item2[key]){
                    return false;
                }
            }
        }
        return true;
    }

    static findItem(value:any,itemsList:ItemsList){
        for(let item of itemsList.items){
            if(NgSelectUtil.isItemEqual(item.value,value)){
                return item;
            }
        }
        return null;
    }
}